import React, { useState } from 'react'
import { 
  Box, 
  Card, 
  Typography, 
  Button,
  useTheme
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { BaseButton, BioContainer, BioOverlay, CollapseButton, SocialCard } from '../styled';
import useCurrentUserInfo from '../../../hooks/useCurrentUserInfo';
import MarkdownRenderer from '../../../components/MarkdownRenderer';
import { useSelector } from 'react-redux';

function ProfilePreview() {

  const userInfo = useCurrentUserInfo();
  const chefProfileInfo = useSelector((state) => state?.userData?.chefProfileInfo);

  const [isExpanded, setIsExpanded] = useState(false);
  
  const chefData = {
    name: chefProfileInfo?.username,
    bio: chefProfileInfo?.bioContent,
    instagram: chefProfileInfo?.instagramLink,
    youtube: chefProfileInfo?.youtubeLink,
  };
  
  const {
    name,
    bio,
    instagram,
    youtube
  } = chefData;

  return (
    <Box sx={{ padding: '1rem' }}>
      {/* Bio Section */}
      <Card 
        sx={{ 
          padding: '1rem', 
          marginBottom: '1rem',
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
        }}
      >
        <Box 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            marginBottom: '1rem' 
          }}
        >
          <PersonIcon sx={{ marginRight: '0.5rem' }} />
          <Typography variant="h6">
            Bio - {name}
          </Typography>
        </Box>
        
        <BioContainer expanded={isExpanded}>
          <MarkdownRenderer content={bio}/>
          {!isExpanded && (
            <BioOverlay />
          )}
        </BioContainer>

        <Button
          fullWidth
          onClick={() => setIsExpanded(!isExpanded)}
          endIcon={isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        >
          {isExpanded ? 'Show Less' : 'Read More'}
        </Button>
      </Card>

      {/* Social Links */}
      {instagram && (
        <SocialCard onClick={() => window.open(instagram, '_blank')}>
          <InstagramIcon sx={{ marginRight: '1rem', color: '#E1306C' }} />
          <Typography noWrap>
            {instagram}
          </Typography>
        </SocialCard>
      )}

      {youtube && (
        <SocialCard onClick={() => window.open(youtube, '_blank')}>
          <YouTubeIcon sx={{ marginRight: '1rem', color: 'red' }} />
          <Typography noWrap>
            {youtube}
          </Typography>
        </SocialCard>
      )}
    </Box>
  );
}


export default ProfilePreview;